import queryEnum from './query-enum.vue'

queryEnum.install = (Vue) =>{
  Vue.component(queryEnum.name,queryEnum);
};

export default {
  queryEnum
};



// WEBPACK FOOTER //
// ./src/components/query-enum/index.js